<script>
export default {
    name: 'ConstantPage',
    data() {
        return {
            COMPANY_ID: 149
        }
    }
}
</script>